import { useState } from "react";
import axios from "axios";
import "./contactUs.css";
import IsLoading from "../../../IsLoading";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SendIcon from "@mui/icons-material/Send";
import CallIcon from "@mui/icons-material/Call";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";

export default function ContactUs() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const redirect = useNavigate();

  const [loading, setLoading] = useState(false);
  const [jsonFullname, setFullName] = useState("");
  const [jsonEmail, setjsonEmail] = useState("");
  const [JsonMessage, setJsonMessage] = useState("");
  const [jsonAddress, setjsonAddress] = useState("");
  const [errors, setErrors] = useState({});

  const data = {
    jsonFullname,
    jsonEmail,
    JsonMessage,
    jsonAddress,
  };

  const validateForm = () => {
    let newErrors = {};

    if (!jsonFullname.trim()) {
      newErrors.jsonFullname = "Full Name is required";
    }

    if (!jsonEmail.trim()) {
      newErrors.jsonEmail = "Email address is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(jsonEmail)) {
      newErrors.jsonEmail = "Enter a valid email address";
    }

    if (!JsonMessage.trim()) {
      newErrors.JsonMessage = "Message is required";
    }

    if (!jsonAddress.trim()) {
      newErrors.jsonAddress = "Address is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  async function submit() {
    if (!validateForm()) return;

    setLoading(true);

    const data = {
      jsonFullname,
      jsonEmail,
      JsonMessage,
      jsonAddress,
    };

    await axios
      .post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/contactUs`,
        data
      )
      .then((response) => {
        enqueueSnackbar(
          "Thank you for Contacting us, we will respond soon!",
          {
            variant: "success",
            autoHideDuration: 3000,
            ContentProps: {
              style: {
                fontSize: "16px",
                fontWeight: "bold",
              },
            },
          }
        );

        window.location.reload();
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar("Something went wrong!", {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: {
              fontSize: "16px",
              fontWeight: "bold",
            },
          },
        });

        console.log(err?.code || "REQUEST_FAILED");
        setLoading(false);
      });
  }

  return (
    <section className="sectioncontactUs fx-cl">

      {loading ? <IsLoading /> : null}

      {/* ================================================================
          HERO
      ================================================================= */}

      <div className="contactHero">

        <div className="contactHeroGlow contactHeroGlowOne"></div>
        <div className="contactHeroGlow contactHeroGlowTwo"></div>

        <div className="contactHeroInner">

          <div className="contactHeroBadge">
            <span className="contactHeroBadgeDot"></span>
            Universe Inventory Support
          </div>

          <h1>
            Let's build a better
            <span> inventory experience.</span>
          </h1>

          <p>
            Whether you have a question, need technical assistance,
            want to explore our solutions, or are planning an enterprise
            deployment, our team is here to help.
          </p>

          <div className="contactHeroActions">

            <button
              type="button"
              className="contactHeroPrimary"
              onClick={() =>
                document
                  .getElementById("universe-contact-form")
                  ?.scrollIntoView({
                    behavior: "smooth",
                  })
              }
            >
              <SendIcon />
              Start a Conversation
            </button>

            <button
              type="button"
              className="contactHeroSecondary"
              onClick={() => redirect("/solutions/all-solutions")}
            >
              Explore Universe Inventory
            </button>

          </div>

        </div>

      </div>


      {/* ================================================================
          CONTACT CHANNELS
      ================================================================= */}

      <div className="contactChannels">

        <div className="contactChannelsHeader">

          <span className="contactEyebrow">
            WE ARE HERE TO HELP
          </span>

          <h2>
            One platform.
            <span> One team behind you.</span>
          </h2>

          <p>
            Connect with Universe Inventory whenever you need assistance,
            guidance, or more information about our platform.
          </p>

        </div>


        <div className="contactChannelGrid">

          <div className="contactChannelCard">

            <div className="contactChannelIcon">
              <LocationOnIcon />
            </div>

            <div className="contactChannelContent">
              <span>LOCATION</span>

              <h3>Connect With Us</h3>

              <p>
                Tell us where your business operates so our team can
                better understand your environment and requirements.
              </p>

              <div className="contactChannelLink">
                Business &amp; Customer Support
              </div>
            </div>

          </div>


          <div className="contactChannelCard contactChannelCardFeatured">

            <div className="contactChannelIcon">
              <CallIcon />
            </div>

            <div className="contactChannelContent">
              <span>SUPPORT</span>

              <h3>We're Ready to Listen</h3>

              <p>
                Have a question about your account, inventory,
                transactions, integrations, or one of our applications?
                Reach out to us.
              </p>

              <div className="contactChannelLink">
                Customer &amp; Technical Support
              </div>
            </div>

          </div>


          <div className="contactChannelCard">

            <div className="contactChannelIcon">
              <SendIcon />
            </div>

            <div className="contactChannelContent">
              <span>MESSAGE</span>

              <h3>Send Your Message</h3>

              <p>
                Share what you need with our team and we'll work with
                you toward the right solution.
              </p>

              <div className="contactChannelLink">
                Start a Conversation
              </div>
            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          MAIN CONTACT AREA
      ================================================================= */}

      <div
        id="universe-contact-form"
        className="contactMainArea"
      >

        <div className="contactMainGrid">


          {/* ============================================================
              LEFT INFORMATION PANEL
          ============================================================= */}

          <div className="contactInformation">

            <div className="contactInformationBadge">
              <span></span>
              CONTACT UNIVERSE INVENTORY
            </div>

            <h2>
              Tell us what
              <strong> you need.</strong>
            </h2>

            <p className="contactInformationLead">
              Every business is different. Tell us about your question,
              challenge, or requirement and our team can better understand
              how to assist you.
            </p>


            <div className="contactReasons">

              <div className="contactReason">

                <div className="contactReasonNumber">
                  01
                </div>

                <div>
                  <h3>Product Assistance</h3>

                  <p>
                    Questions about inventory, POS, barcode scanning,
                    transactions, reports, or other platform features.
                  </p>
                </div>

              </div>


              <div className="contactReason">

                <div className="contactReasonNumber">
                  02
                </div>

                <div>
                  <h3>Technical Support</h3>

                  <p>
                    Get help understanding technical issues,
                    integrations, applications, and platform behavior.
                  </p>
                </div>

              </div>


              <div className="contactReason">

                <div className="contactReasonNumber">
                  03
                </div>

                <div>
                  <h3>Business &amp; Enterprise</h3>

                  <p>
                    Discuss larger deployments, business requirements,
                    enterprise workflows, and customized solutions.
                  </p>
                </div>

              </div>

            </div>


            <div className="contactTrustCard">

              <div className="contactTrustIcon">
                ✓
              </div>

              <div>
                <strong>Your message matters.</strong>

                <p>
                  We review every submission and use the information
                  you provide to understand how we can assist you.
                </p>
              </div>

            </div>

          </div>


          {/* ============================================================
              FORM
          ============================================================= */}

          <div className="contactUsForm">

            <div className="contactFormTop">

              <div className="contactFormIcon">
                <SendIcon />
              </div>

              <div>
                <span>GET IN TOUCH</span>

                <h2>Send us a Message</h2>

                <p>
                  Complete the form below and tell us how we can help.
                </p>
              </div>

            </div>


            <div className="contactFormDivider"></div>


            {/* FULL NAME */}

            <div className="contactInputGroup">

              <label>
                Full Name
                <span>*</span>
              </label>

              <input
                type="text"
                name="jsonFullname"
                value={jsonFullname}
                onChange={(event) => {
                  setFullName(event.target.value);

                  if (errors.jsonFullname) {
                    setErrors((previous) => ({
                      ...previous,
                      jsonFullname: "",
                    }));
                  }
                }}
                placeholder="Enter your full name"
                className={
                  errors.jsonFullname
                    ? "contactInput contactInputError"
                    : "contactInput"
                }
              />

              {errors.jsonFullname && (
                <small className="contactError">
                  {errors.jsonFullname}
                </small>
              )}

            </div>


            {/* EMAIL */}

            <div className="contactInputGroup">

              <label>
                Email Address
                <span>*</span>
              </label>

              <input
                type="text"
                name="jsonEmail"
                value={jsonEmail}
                onChange={(event) => {
                  setjsonEmail(event.target.value);

                  if (errors.jsonEmail) {
                    setErrors((previous) => ({
                      ...previous,
                      jsonEmail: "",
                    }));
                  }
                }}
                placeholder="you@example.com"
                className={
                  errors.jsonEmail
                    ? "contactInput contactInputError"
                    : "contactInput"
                }
              />

              {errors.jsonEmail && (
                <small className="contactError">
                  {errors.jsonEmail}
                </small>
              )}

            </div>


            {/* MESSAGE */}

            <div className="contactInputGroup">

              <div className="contactLabelRow">

                <label>
                  Message
                  <span>*</span>
                </label>

                <span className="contactOptional">
                  Tell us as much as you can
                </span>

              </div>

              <textarea
                name="JsonMessage"
                cols="30"
                rows="6"
                value={JsonMessage}
                onChange={(event) => {
                  setJsonMessage(event.target.value);

                  if (errors.JsonMessage) {
                    setErrors((previous) => ({
                      ...previous,
                      JsonMessage: "",
                    }));
                  }
                }}
                placeholder="Describe your question, issue, idea, or requirement..."
                className={
                  errors.JsonMessage
                    ? "contactInput contactTextarea contactInputError"
                    : "contactInput contactTextarea"
                }
              ></textarea>

              {errors.JsonMessage && (
                <small className="contactError">
                  {errors.JsonMessage}
                </small>
              )}

            </div>


            {/* ADDRESS */}

            <div className="contactInputGroup">

              <label>
                Business / Location
                <span>*</span>
              </label>

              <input
                type="text"
                name="jsonAddress"
                value={jsonAddress}
                onChange={(event) => {
                  setjsonAddress(event.target.value);

                  if (errors.jsonAddress) {
                    setErrors((previous) => ({
                      ...previous,
                      jsonAddress: "",
                    }));
                  }
                }}
                placeholder="Country, state, city, or business location"
                className={
                  errors.jsonAddress
                    ? "contactInput contactInputError"
                    : "contactInput"
                }
              />

              {errors.jsonAddress && (
                <small className="contactError">
                  {errors.jsonAddress}
                </small>
              )}

            </div>


            {/* SUBMIT */}

            <button
              type="button"
              className="contactSubmitButton"
              onClick={submit}
              disabled={loading}
            >

              <span>
                {loading
                  ? "Sending Message..."
                  : "Send Message"}
              </span>

              {!loading && <SendIcon />}

            </button>


            <div className="contactFormSecurity">

              <span className="contactSecurityIcon">
                ✓
              </span>

              <span>
                Your information is submitted securely and is used
                to help us respond to your request.
              </span>

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          PLATFORM SUPPORT SECTION
      ================================================================= */}

      <div className="contactSupportSection">

        <div className="contactSupportInner">

          <div className="contactSupportHeading">

            <span className="contactEyebrow">
              UNIVERSE ECOSYSTEM
            </span>

            <h2>
              More than inventory.
              <span> A connected business platform.</span>
            </h2>

            <p>
              Universe Inventory is designed around the way modern
              businesses actually operate — connecting inventory,
              sales, scanning, notifications, and business operations
              into one ecosystem.
            </p>

          </div>


          <div className="contactSupportCards">

            <div className="contactSupportCard">

              <div className="contactSupportCardTop">
                <span>01</span>
                <SendIcon />
              </div>

              <h3>Universe Inventory</h3>

              <p>
                Manage products, stock, purchases, sales, transfers,
                adjustments, reports, and the wider inventory workflow
                from one central platform.
              </p>

            </div>


            <div className="contactSupportCard">

              <div className="contactSupportCardTop">
                <span>02</span>
                <CallIcon />
              </div>

              <h3>Universe Point of Sale</h3>

              <p>
                Power your sales operation with a connected POS
                experience designed to work alongside your inventory
                management environment.
              </p>

            </div>


            <div className="contactSupportCard">

              <div className="contactSupportCardTop">
                <span>03</span>
                <LocationOnIcon />
              </div>

              <h3>Universe Connected Apps</h3>

              <p>
                Extend your workflow with connected applications
                designed for real-time notifications, barcode scanning,
                and operational visibility.
              </p>

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================
          FINAL CTA
      ================================================================= */}

      <div className="contactFinalCTA">

        <div className="contactFinalCTAGlow"></div>

        <div className="contactFinalCTAContent">

          <span className="contactEyebrow">
            READY WHEN YOU ARE
          </span>

          <h2>
            Let's move your business
            <span> forward.</span>
          </h2>

          <p>
            Have a question today or planning something bigger for
            tomorrow? Universe Inventory is ready to hear from you.
          </p>

          <button
            type="button"
            onClick={() =>
              document
                .getElementById("universe-contact-form")
                ?.scrollIntoView({
                  behavior: "smooth",
                })
            }
          >
            <span>Contact Universe Inventory</span>
            <SendIcon />
          </button>

        </div>

      </div>

    </section>
  );
}
